module.exports = __webpack_public_path__ + "static/media/add-friend-header.dc31285a.svg";